class ingredientsTable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachShadow({ mode: 'open' });
    const template = this.querySelector('template').content.cloneNode(true);
    this.shadowRoot.appendChild(template);

    this.renderTable();
  }

  renderTable(){
    const dataScript = this.querySelector('script[type="application/json"]');
    const tableInfo = JSON.parse(dataScript.textContent);
    const tableBody = this.shadowRoot.querySelector('.table-body');

    tableInfo.forEach(row => {
      let newRow = '<div class="table-row">';
    
      row.forEach((item, i) => {
        if (Array.isArray(item)) { 
          let columnContent = ''; 
          newRow = newRow.replace('"table-row"', '"table-row table-row-column"');

          item.forEach((subItem, idx) => {
            columnContent += `<span class='col  col-${idx + 1}'>${subItem}</span>`;
          });
    
          newRow += `<span class="subcol">${columnContent}</span>`; 
        } else {
          newRow += `<span class="col col-${i + 1}">${item}</span>`;
        }
      });
    
      newRow += '</div>';
      tableBody.innerHTML += newRow; 
    });
    
  }
}

customElements.define("ingredients-table", ingredientsTable );
